import { InputsFinalize } from './../index';

import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";

import useFacility from "../../../../utils/hooks/useFacility";
import { GET_CARD_DEFINITIONS, GET_PAYMENT_DEFINITIONS } from "../../../api/apiRoutes";
import { DepositDefinition } from "../../../models/DepositDefinition";
import { setSaveAccountIncomeData } from "../../../models/SaveAccountIncomeData";

export default function useECard() {
  const facilityIds = useFacility();
  const [type, setTypesDefinition] = useState<DepositDefinition[]>([]);
  const [paymentUrl, setPaymentUrl] = useState<string>("");

  const { get, post } = useApiRequest();

  const requestGetAssortGroups = async () => {
    const { result, isError } = await get(GET_CARD_DEFINITIONS(facilityIds));
    if (!isError) {
      setTypesDefinition(result);
    }
  };

  const requestPaymentDefinition = async (data: InputsFinalize, definition: number) => {
    const { result, isError } = await post(GET_PAYMENT_DEFINITIONS, {
      Ids: definition,
      facilityIds,
      ...setSaveAccountIncomeData(data),
    });
    if (!isError) {
      setPaymentUrl(result.PaymentURL);
    }
  };

  return {
    paymentUrl,
    requestPaymentDefinition,
    requestGetAssortGroups,
    type,
  };
}
